import styled from "styled-components"
import {
  ContainerStyles,
  DescriptionContainerStyles,
  DescriptionStyles,
  ImageContainerStyles,
  MediaOptionsStyles,
  MediaStyles,
  OptionIconStyles,
  TitleSectionStyles,
  VideoPlayStyles,
} from "./media-preview-styles"
import { colors } from "../../helpers/colors"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px 0;
  ${ContainerStyles}
`

export const ImageContainer = styled.div`
  position: relative;
  ${ImageContainerStyles}
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${DescriptionContainerStyles}
`

export const TitleSection = styled.section`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${TitleSectionStyles}
`

export const MediaOptions = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  margin-top: 25px;
  ${MediaOptionsStyles}
`

export const OptionIcon = styled.img`
  height: 100%;
  margin-left: 20px;
  ${OptionIconStyles}
`

export const VideoPlay = styled.img`
  position: absolute;
  cursor: pointer;
  z-index: 2;
  width: 100px;
  height: 100px;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
  ${VideoPlayStyles}
`

export const Media = styled.img`
  width: 100%;
  transition: 0.1s all ease;
  cursor: pointer;
  border: 1px solid ${colors.gray};
  ${MediaStyles}
`

export const Description = styled.p`
  margin: 0;
  color: ${colors.gray};
  ${DescriptionStyles};
`
